import React from "react";
import TermsNav from "../../components/Navbar/TermsNav";
import Footer from "../../components/Footer/Footer";
import Aside from "./Aside";
import Bullet from "../../components/Bullet/Bullet";
import ScrollUpButton from "react-scroll-up-button";

const Terms = () => {
  return (
    <div className="terms">
      <div className="scroll">
        <ScrollUpButton />
      </div>
      <TermsNav />
      <div className="terms-and-conditions">
        <section className="terms-and-conditions-top">
          <div className="terms-and-conditions-top-text">
            Terms and Conditions
          </div>
        </section>

        <div className="terms-and-conditions-body">
          <Aside />
          <main>
            <section className="terms-and-conditions-body-section" id="terms">
              <header>Terms and Conditions</header>
              <h1>
                GENERAL TERMS AND CONDITIONS OF USE FOR NIBSS PRODUCTS AND
                SERVICES
              </h1>
              <p>
                In this GTC, use of the words "We", Our and "Us" shall refer to
                NIBSS, and use of the words "You/User/Your" shall refer to
                NIBSS’ clients/customers who subscribe for the NIBSS Electronic
                Portals and Industry Services (which expression shall where the
                context so admits include its successors-in-title and assigns).
              </p>
              <p>
                YOU AGREE THAT THESE GENERAL TERMS AND CONDITIONS (the “GTC”)
                POSTED ON THIS WEBSITE WILL BE EFFECTIVE TO ALL USERS AS OF JULY
                1, 2018. A COPY OF THE GTC MAY ALSO BE OBTAINED FROM THE NIBSS
                OFFICE AT 1230 AHMADU BELLO WAY, VICTORIA ISLAND, LAGOS.
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="scope-of-the-GTC"
            >
              <h5>Scope of the GTC</h5>
              <p>
                NIBSS is a shared service infrastructure set up by all Nigerian
                licensed banks, and the Central Bank of Nigeria to provide
                electronic payments, transactions switching, payments
                aggregation, payments sweeping and settlement services and
                shared-service platforms for the financial services industry.
                NIBSS has agreed to provide its Electronic Portals and Industry
                Services, and User has agreed to the use of or subscription to
                any NIBSS Electronic Portals and Industry Services subject to
                the terms and conditions contained in this GTC.
              </p>
              <p>
                This GTC is a contract between User and NIBSS and governs Your
                use of and subscription to all NIBSS Electronic Portals and
                Industry Services, which include the Industry Address
                Verification Service. Using the NIBSS Electronic Portal and
                Services means that User must accept all of the terms and
                conditions contained in this GTC and all other agreements,
                including the relevant Subscription Agreement for any NIBSS
                Electronic Portals and Industry Services which User may
                subscribe to. User should read all of the terms of this GTC
                carefully.
              </p>
              <p>
                NIBSS may amend this GTC at any time by posting a revised
                version on the NIBSS’ website. The revised version will be
                effective at the time it is posted by NIBSS. If the revised
                version includes a Substantial Change, NIBSS will provide User
                with 15 Days' prior notice of any Substantial Change by posting
                a notice of same on the NIBSS website. All future changes set
                out in any revised version already published on the NIBSS
                website at the time You subscribe for the NIBSS Electronic
                Portals and Industry Services are incorporated by reference into
                this GTC and will take effect as specified in that revised
                version.
              </p>
              <p>
                NIBSS reserves the right to close, suspend, or limit Your access
                to the NIBSS electronic Portals and services if You violate this
                GTC, or any other agreement You enter into with NIBSS.
              </p>
            </section>

            <section
              className="terms-and-conditions-body-section"
              id="definition"
            >
              <h5>Definition</h5>
              <p>
                As used in this GTC and any other agreements between You and
                NIBSS, the following words and expressions shall have the
                following meanings, except to the extent otherwise defined in
                such other agreements
              </p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Account Holder - means any legal entity or natural person
                    who has an account in a financial Institution and/or the
                    individual or entity legally responsible for all charges
                    made on a specific account held in a Financial Institution;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Account Transaction - means any commercial transaction that
                    takes place on the account held and processed by a Financial
                    Institution where the account is domiciled;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Acquirer - any DMB, CBN licensed Financial Institution or
                    entities that manages Sellers’ accounts and is able to
                    receive payments into such accounts;
                  </p>
                </li>

                <li className="agreements">
                  <Bullet />
                  <p>
                    Acquiring Bank - means any DMB, CBN licensed financial
                    institution(s) that maintains each Beneficiary’s bank
                    account;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Admin User - Your designated officer who has the highest
                    level of access to the NIBSS Electronic Portal(s) and
                    Industry Service(s) accounts and functions;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Administrator - means a designated official of either Party
                    who is responsible for the upkeep, configuration, and
                    reliable operation of Party’s systems;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Advance Notice - refers to the notice that must be given by
                    a Biller to a Payer who has signed a Direct Debit Mandate in
                    respect of the first payment and any changes to the date
                    and/or amount to be debited; A prior notification by the
                    Biller to the Subscriber that the amount to be debited from
                    the Subscriber’s Bank Account or the date on which such
                    amount is to be debited pursuant to a Direct Debit Mandate
                    has been altered;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Aggregators - means a person or organization that collects
                    information about a particular good/service providers, make
                    the providers their partners, and sell their services under
                    its own brand;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    API - means the application program interface for building
                    or exposing software applications to customers;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>AML - means Anti-Money Laundering;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Anti-Corruption Laws - means applicable laws and regulations
                    including but not limited to The Corrupt Practices and other
                    Related Offences Act, 2000 Money Laundering (Prohibition)
                    Act, 2011 (as amended), Economic and Financial Crimes Act,
                    2004, Advanced Fee Fraud and Other Related Offences Act,
                    1995;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Automated Direct Debit - refers to the electronic conversion
                    of Direct Debit Instructions;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Authorised Signatories - means the persons authorised by
                    Your Board’s Resolution to access any of Our platform or
                    enter into an agreement with NIBSS on Your behalf;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Banking and Payments System in Nigeria - means the
                    operational systems, technologies, instruments, people,
                    rules, procedures, standards used to make financial
                    transactions and monetary exchange possible.;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Bank - means a deposit taking institution duly licensed by
                    the CBN;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Bank Account - means a financial account maintained by an
                    individual in a Financial Institution profiled for
                    Electronic Banking services and can be used as means of
                    payment for goods and services;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Batch - means a series of electronic financial card
                    transactions in settlement;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Beneficiary - means the recipient of the payment transferred
                    by the Settlement Bank to the Beneficiary’s account with the
                    Acquiring Bank; or recipients of funds paid using a CBN
                    approved platform;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Biller - means an organization or individual that is able to
                    make a request for a Direct Debit Collection or pass a bill
                    to customer for the service provided;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Biller’s Bank - means the bank where the Biller maintains a
                    bank account; it is the bank that presents the debit
                    instruction for payment;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Banking and Payments System in Nigeria - means the
                    operational systems, technologies, instruments, people,
                    rules, procedures, standards used to make financial
                    transactions and monetary exchange possible.;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Business Day - means Monday through Friday, excluding the
                    official national holidays recognized in Nigeria.;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>BVN - means Bank/Biometric Verification Number;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    BVN Validation Portal - means a web based automated unique
                    identifier management system designed to process and verify
                    every bank customer’s unique information;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Card - means a payment card used as means of payment for
                    goods and services;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Card Not Present - means a transaction where the physical
                    card is not present at the time of the transaction, like
                    telephone orders, etc.;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Cardholder - means any legal entity or natural person to
                    whom a card is issued and/or who is authorized to use it;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Card Issuer - means any entity legally entitled to issue
                    cards which are acceptable to NIBSS;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Card Transaction - means any commercial transaction for
                    which the card and card processing equipment are used;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>CBN - means Central Bank of Nigeria;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    CBN Licensed Financial Institution - means any licensed
                    deposit-taking institution such as DMB, MFB, PMB, MMO or
                    other payment solution provider licensed by the CBN;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Central Pay - means the NIBSS electronic payment solution
                    used for payment of goods and services through electronic
                    commerce platform;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>CFT - means Combating the Financing of Terrorism;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>CMMS - means Central Mandate Management Systems;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    CMMS Portal - means a web based automated management system
                    designed to process and verify every bank customer’s unique
                    information and their mandates;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Competent Public Authority - means any relevant authority,
                    including but not limited to the courts, which is involved
                    or connected with the service;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Consent - means any freely given, specific, informed and
                    unambiguous indication of the Data Subject's wishes by which
                    he or she, by a statement or by a clear affirmative action,
                    signifies agreement to the processing of Personal Data
                    relating to him or her;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Customer - means Your existing or prospective client(s);
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Customer Information - means any information distilled from
                    any of Our Electronic Portals and Industry Services in
                    respect of a Customer;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Customer Account(s) - means user identification(s) including
                    user name, password, codes and other data issued by You to
                    Customers to facilitate access to the Portal;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Data Subject - means an identifiable person; one who can be
                    identified directly or indirectly, in particular by
                    reference to an identification number or to one or more
                    factors specific to his physical, physiological, mental,
                    economic, cultural or social identity;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Debit Card - means a card giving online access to the
                    cardholder’s bank account, allowing an immediate debit to
                    this account of the full transaction amount;;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>Destination Bank - means the beneficiary bank;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Deposit Bank - means a single, centralized place to manage
                    all billing information about your customers –including
                    company and contact information and payment terms and
                    preferred payment methods;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Direct Debit - means a form of financial settlement that
                    facilitates settlement of “regular in nature" payments. It
                    is an instruction from a Subscriber to their bank
                    authorizing an organization to collect funds from their
                    account;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Direct Debit Collection - means the crediting of value into
                    the Biller’s Bank Account with the Biller Bank by debiting
                    the Subscriber’s Bank Account pursuant to a Direct Debit
                    Instruction;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Direct Debit Indemnity - means indemnity which protects a
                    Subscriber in the event that a debit occurs outside the
                    terms agreed between the Subscriber and Biller in the Direct
                    Debit contract, that is, where a payment is unauthorized by
                    the Subscriber, the Subscriber’s Bank shall, on request,
                    make an immediate refund to the Subscriber’s Bank account.
                    Direct Debit Indemnity covers situations where a Biller may
                    not have given the required Advance Notice regarding a
                    change of amount or date;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Direct Debit Instruction - means a payment request designed
                    in a specified format, presented by a Biller’s Bank on
                    behalf of a Biller to a Subscriber’s Bank based on the
                    existence of a confirmed Direct Debit Mandate issued by a
                    Subscriber.;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Direct Debit Mandate or DDM - means an authority given by a
                    Subscriber to the Subscriber Bank to make payments from an
                    identified account at the request of the Subscriber. The DDM
                    allows a Biller to collect only amounts that have been
                    authorized by a Subscriber on or after a specified date;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>DMB - means Deposit Money Banks;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    E-Passport Verification Portal - refers to an on-line portal
                    for the verification of Customer’s international passport
                    provided as a means of Customer identification for account
                    opening and other purposes managed by NIBSS in collaboration
                    with Nigeria Immigration Service.;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    e-Reference Portal - means a web based automated document
                    management system, designed to process customer account
                    references managed by NIBSS;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    File Transfer Protocol - means a standard network protocol
                    used for the transfer of computer files from a server to a
                    client using the Client–server model on a computer network;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Financial Institutions - means a company under the
                    supervisory purview of CBN, licensed to carry on business of
                    providing financial services for consumers and to
                    industrial, commercial, or agricultural enterprises which
                    include: funds management; equipment leasing; fire-purchase;
                    debts factoring and securitisation; project financing or
                    consultancy; debt administration; LPO financing; project
                    financing; export financing; financial consultancy; and
                    issuing of vouchers, coupons, credit cards and token stamps
                    and such other businesses as the CBN may, from time to time,
                    designate.;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Fraudulent Practice - means any act or omission, including
                    any misrepresentation, that knowingly misleads, or attempts
                    to mislead, a party to obtain any financial or other
                    advantage, or to avoid any obligation, to benefit the
                    perpetrator or a related party;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Fraudulent Transaction - means transactions that in common
                    law or in accordance with any statutory provision
                    constitutes fraud, regardless of whether the account
                    holder’s bank has given an authorization or not;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>GSM - means Global Systems for Mobile Communications;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Hot-Card-File - means an electronic file of cards that are
                    invalid due to loss, theft or on which fraud has been
                    reported;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Identity - means the set of information provided by which a
                    customer is definitively recognizable.;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Identification System Service Providers - means an
                    independent third party providing an automated Identity
                    tracking systems service;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    I’m Alive Verification - means one-to-one real time
                    verification of pensioners using a fingerprint scanner
                    against the biometric template tied to the NIBSS BVN
                    database;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>IMEI - Means International Mobile Equipment Identity;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>IMSI - means International Mobile Subscriber Identity;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Internet Banking - means a service provided by Financial
                    Institutions that allows persons conduct transactions such
                    as bill payment, confirmation of information about their
                    Bank Account, etc. electronically through a web
                    portal/internet;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Internet Banking Profile - means the Account Holder’s Unique
                    Information and log-in details that enable Account Holder
                    access Internet Banking;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>Issuing Bank - means the Payer bank;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Issuer - means a Financial Institution (FI) who manages
                    payers accounts and is able to authorise payers’ debit
                    transactions;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Know Your Customer/KYC - means the process employed by
                    financial institutions/other financial institutions to
                    verify the identity of their Customer and obtain detailed
                    information about their clients’ risk tolerance and
                    financial position;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Learning Platform - refers to an on-line e-learning platform
                    that acts as a center or go-to website for a variety of
                    courses, providing learners with knowledge and skills
                    required for personal improvement, or improvement on job
                    performance;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Material Breach - means failure of a Party to perform its
                    obligation under this GTC that is significant enough to
                    substantially destroy the value or benefit that the innocent
                    or affected Party would otherwise have derived from this
                    GTC;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Merchant - means the owner of an outlet (physical or online)
                    providing goods and/or services for sale to an Account
                    Holder and in whose premises/site electronic payment is
                    accepted as a means of payment;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Merchant Acquirer/Acquirer - means the financial institution
                    that maintains the Merchant’s bank account and accept credit
                    transactions on behalf of the Merchants from the Issuing
                    Bank;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Merchant Commission - means the fees payable by the merchant
                    and shall have the same meaning as Merchant discount;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Merchant Enroller - means any registered company, other than
                    a CBN licensed financial institution, approved by NIBSS to
                    enroll and on-board Merchants to the mCASH payment solution;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Merchant Identification Number - means a number provided by
                    NIBSS to identify the Merchant in a transaction;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Merchant Operating Manual - means a detailed description and
                    instructions to the Merchant relating to the operating
                    procedures and processing of valid card transactions;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Merchant Service Charge - means to fee payable by the
                    Merchant for the service of the processor and other
                    stakeholders;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>MFB - means Microfinance Bank;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>MMO - means Mobile Money Operator;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    MSISDN - means Mobile Station International Subscriber
                    Directory Number;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>NES - means NIP Name Enquiry Service;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    NAPS -means NIBSS Automated Payment System (NAPS), an
                    integrated multi-bank e-payment, e-collection and payroll
                    &amp; bulk payment platform designed for the instant
                    processing of payroll, pension, personnel records and
                    execution of funds transfer, direct debit, collections,
                    schedule delivery and payment instructions;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    NAPS Portal - means a website that serves as an integrated
                    multi-bank e-payment, e-collection and payroll &amp; bulk
                    payment platform;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>NCC - means Nigerian Communications Commission;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>NCS - means Nigeria Central Switch;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    NIBSS E-Portal and Industry Services - means those value
                    added services NIBSS offers to banks and other players in
                    the financial and non-financial sectors to reduce costs,
                    optimize service delivery, enhance operational efficiency
                    and ease the performance of day to day routine activities in
                    the financial and non-financial sectors.;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>NIP NES - means NIP Name Enquiry Service;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>NIP Platform - means NIBSS Instant Payment platform;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    NIP Transaction - means a transaction transferred on the
                    NIBSS instant payment platform from a source bank by sender
                    to a Destination Bank for the Beneficiary;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>OFI - means Other Financial Institutions;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>OTP - means one time password;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Payer - Means an entity that makes payment (or is
                    contractually or legally required to make payment) to
                    another entity;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>Parties - means NIBSS and User;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>Party - means either NIBSS or User;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Participating Bank - means a source/sending or
                    destination/receiving bank;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    PCI DSS - means Payment Card Industry Data Security
                    Standards;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Penalty - means a fine levied by NIBSS for the contravention
                    of their regulations and/or operational risk parameters by
                    the Merchant;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Personal Data - means any information relating to an
                    identified or identifiable natural person (‘Data Subject’);
                    an identifiable natural person is one who can be identified,
                    directly or indirectly, in particular by reference to an
                    identifier such as a name, an identification number,
                    location data, an online identifier or to one or more
                    factors specific to the physical, physiological, genetic,
                    mental, economic, cultural or social identity of that
                    natural person; It can be anything from a name, address, a
                    photo, an email address, bank details, posts on social
                    networking websites, medical information, and other unique
                    identifier such as but not limited to MAC address, IP
                    address, IMEI number, IMSI number, SIM and others;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    PIN - means a payment initiator’s personal identification
                    number/code allowing him/her to carry out a transaction
                    securely;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Pin-Driven Card - means a chip-n-PIN card requiring a card
                    holder to enter a PIN into the Point of Sale Terminal or PIN
                    pad or otherwise before carrying out a transaction;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>PMB - means Primary Mortgage Bank;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Point of Sale Terminal - means an electronic device or
                    hardware, used by merchants to accept payments at retail
                    locations;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Principal Account - means the user identification(s)
                    including user name, password, codes, etc. created by NIBSS
                    for User to facilitate access to the respective NIBSS
                    platform, NIBSS Electronic Portals and Industry Services for
                    which the User has subscribed to;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Processor - means any licensed service provider used by the
                    Issuer to authorize and process card transactions; or a
                    natural or legal person, public authority, agency or other
                    body which controls or processes Personal Data on behalf of
                    each Party, as applicable;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Processing - means any operation or set of operations which
                    is performed on Personal Data or on sets of personal data,
                    whether or not by automated means, such as collection,
                    recording, organisation, structuring, storage, adaptation or
                    alteration, retrieval, consultation, use, disclosure by
                    transmission, dissemination or otherwise making available,
                    alignment or combination, restriction, erasure or
                    destruction;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Project/Undertaking - means the integration of User’s
                    payment solution to NIP and NCS infrastructure to provide
                    instant values to User or User’s customers in the payment
                    industry on behalf of User;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Public Key Infrastructure(PKI) - means a security system
                    incorporating the use of digital signatures to ensure the
                    integrity confidentiality of and access to transmitted
                    information/data;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Seller - means any retailer that accepts payments with the
                    USSD-based, on-line/web, or Mobile App/In-App payments
                    platform;;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Seller Enroller - means a Financial Institutions or 3rd
                    party that enroll sellers;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Seller Code - means a unique number assigned to Sellers by
                    Acquirers or their agents;;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Settlement - means part of the clearing process where the
                    Acquirer credits the Merchant’s account with the amount of
                    an account purchase, and the Acquirer debits the Account
                    Holder for the Transaction, thus settling the Transaction;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Settlement Bank - means the Money Deposit Bank that
                    discharges payment obligations arising from inter-bank funds
                    transfers between paying and receiving Financial
                    Institutions in respect of operations that pass through the
                    NIBSS infrastructure;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Settlement Cycle - means the period between one working day
                    and the next one for all transactions that occur on a daily
                    basis within such period from Monday to Friday but excludes
                    weekends, public holidays, and Force Majeure;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>SIM - means Subscriber Identity Module;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>SMS - means Short Message Service;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Source Bank - means the bank or institution from which the
                    name enquiry request originates;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Stakeholders - means all persons, corporate or individuals
                    involved in the process flow of a transaction from the point
                    of initiation to completion;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>STK - means Systems Tool Kit;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Sub Processor - means any data processor engaged by the
                    Processor;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Subscriber - means the party whose Bank Account is to be
                    debited as instructed in a Direct Debit Mandate, typically a
                    customer of a Biller or who has an existing financial
                    relationship with a Biller;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Subscription Agreement - means the agreement between NIBSS
                    and the User that sets out the specific terms and conditions
                    governing the use of the NIBSS’ Electronic Portal(s) and
                    Industry Service(s) subscribed to by the User;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Subscriber’s Bank - means the bank where the Subscriber
                    maintains an account;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Substantial Change - means a change to the terms of this GTC
                    that reduces User’s rights or increases User’s
                    responsibilities;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Test Data - means data that is used to execute tests on
                    software;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Third Party Service Provider - means a separate business
                    entity working with NIBSS to facilitate the NIP Platform and
                    Service;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Transaction - means any action between a cardholder and a
                    Merchant that results in activity on the cardholder’s
                    account, such as a purchase, refund, or reversal and
                    settlement and shall have the same meaning as card
                    transaction;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>USSD - means Unstructured Supplementary Service Data;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Unique Information - means each Account Holder’s
                    identification details such as name, password, and other
                    connectivity protocols;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Unique Short Codes - means short digit sequences that are
                    used to address messages in the systems of mobile network
                    operators;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>IAV - Industry Address Verification;</p>
                </li>
              </ul>
            </section>

            <section
              className="terms-and-conditions-body-section"
              id="interpretation"
            >
              <h5>Interpretation</h5>
              <p>
                The meanings set forth for defined terms in this GTC or in any
                other agreement between NIBSS and You shall be equally
                applicable to both the singular and plural forms of the terms
                defined and the masculine, feminine or neuter gender shall
                include all genders..
              </p>
              <p>
                All references in any other agreement between NIBSS and You to
                clauses, sections, schedules and exhibits are to clauses,
                sections, schedules and exhibits in or to such agreement unless
                otherwise specified therein.
              </p>
              <p>
                References in this GTC and any other agreement between NIBSS and
                You to any statute, decree, regulation or other Applicable Law
                shall be construed as a reference to such statute, law, decree,
                regulation or other Applicable Law as re-enacted, re-designated,
                amended or extended from time to time.
              </p>
              <p>
                References to the words “include” or “including” shall be deemed
                to be followed by “without limitation” or “but not limited to”,
                whether or not they are followed by such phrases or words of
                similar import.
              </p>
              <p>
                References to a number of days shall refer to calendar days
                unless Business Days are otherwise specified
              </p>
            </section>

            <section
              className="terms-and-conditions-body-section"
              id="industry-address-verification-platform"
            >
              <h5>Industry Address Verification Platform (IAV)</h5>
              <p>This sets expectations of all parties in the IAV platform</p>
              <p>
                Nigerian Inter-Bank Settlement System shall be held accountable
                for the following:
              </p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Ensure collection of information from the Bank and provision
                    of same to the Verification Agency;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Transmission of feedback from the Verification Agency to the
                    Bank;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>Proper monitoring of Agent activities for efficiency;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>Response to enquiries from Banks within agreed SLA;</p>
                </li>
              </ul>
              <p>The Bank shall be responsible for the following:</p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>Monthly payment for Services rendered at agreed rate;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Provision of quality data input for verification activities;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>Response to enquiries from Agents via the IAV platform;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Proper IT infrastructure to support integration with the
                    service and system stability after go live;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Prevent interaction with Agents to preserve objectivity of
                    the process;
                  </p>
                </li>
              </ul>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="compliance"
            >
              <h5>Compliance</h5>
              <p>
                In connection with the exercise of User’s rights and obligations
                under this GTC User will comply, at User’s own expense, with all
                laws, policies, guidelines, regulations, ordinances, rules
                applicable to User, this GTC, Subscriber Agreement(s) or
                transactions conducted on the NIBSS platform and/or orders of
                any governmental authority or regulatory body having
                jurisdiction over the subject matter hereof, including but not
                limited to those related to taxes.
              </p>
              <p>
                User shall be responsible for its respective levies, charges,
                contributions or taxes in connection with the NIBSS services
                subscribed to, including obtaining tax certificate or exemption
                certificate as may be required in accordance with the provisions
                of any laws, regulations or directives for the time being in
                force in Nigeria
              </p>
              <p>
                User shall not use the NIBSS portals and services in any manner,
                or in furtherance of any activity that may cause NIBSS to be
                subject to investigation, prosecution, or legal action.
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="representations-and-warranties"
            >
              <h5>Representations and Warranties</h5>
              <p>Each of the Parties represents and warrants that:</p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>
                    It has corporate power (including, without limitation, under
                    its memorandum and articles of association) to enter into
                    and perform its obligations under this GTC;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    It has in full force and effect the authorisations necessary
                    to enter into this GTC, perform its obligations under it and
                    enforce this GTC;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    It has the requisite facilities, technology and personnel to
                    perform its obligations under this GTC;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    All information provided in relation to this GTC are true,
                    accurate and complete in every respect and are not
                    misleading;
                  </p>
                </li>
              </ul>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="force-majeure"
            >
              <h5>Force Majeure</h5>
              <p>
                Neither Party shall be responsible for any failure to fulfil any
                term or condition of the GTC if and to the extent that
                fulfilment has been delayed or temporarily prevented by a Force
                Majeure occurrence, as hereunder defined, and which is
                unforeseeable, beyond the control, without the fault or
                negligence of the Party affected (Affected Party) and prevents
                the Affected Party from fulfilling its obligations under this
                GTC.
              </p>
              <p>
                For the purposes of this GTC, Force Majeure relates to the
                occurrence of events such as:
              </p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Riot, war, acts of terrorism, civil war, rebellion,
                    revolution, insurrection of military or usurped power;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Earthquake, flood, and/or other natural physical disaster,
                    but excluding weather conditions regardless of severity;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Strikes at a national level or industrial disputes at a
                    national level, or strikes or industrial disputes by labour
                    not employed by the Affected Party and which affect a
                    substantial portion of the provision of the services under
                    this GTC
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Acts or orders of governments or governmental bodies
                    (including legislative bodies, local or port authorities),
                    changes to any general or local Statute, Ordinance, Decree
                    or other Law or any regulation or bye-law of any local or
                    other duly constituted authority or the introduction of any
                    such Statute, Ordinance, Decree, Law, regulation or bye-law
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Regulatory authority’s intervention negating the intention
                    and terms of this GTC;
                  </p>
                </li>
              </ul>
              <p>
                In the event of a Force Majeure occurrence, the Affected Party
                shall promptly notify the other Party in writing, giving the
                full particulars thereof and shall use all reasonable endeavours
                to remedy the situation immediately.
              </p>
              <p>
                Following notification of a Force Majeure occurrence, the
                Parties shall meet without delay with a view to agreeing a
                mutually acceptable course of action to minimize any effects of
                such occurrence
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="confidentiality"
            >
              <h5>Confidentiality</h5>
              <p>
                All information of a non-public, confidential or proprietary
                nature, whether of a commercial, financial or technical nature;
                customer, supplier, product or production related; or otherwise
                all information exchanged in the ordinary course of delivering
                the NIBSS Electronic Portals and Industry Services shall be
                deemed Confidential Information. In recognition of the
                foregoing, User agree(s) and covenant(s) that it shall:
              </p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>
                    keep and maintain all Customers’ information in strict
                    confidence, using the highest degree of care as is
                    appropriate to avoid unauthorized access, use or disclosure;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    use and disclose Customer Information solely and exclusively
                    for the purposes for which the Unique Information, or access
                    to it, is provided pursuant to the terms and conditions of
                    this GTC;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    not use, sell, rent, transfer, distribute, or otherwise
                    disclose or make available Customer Information for the
                    benefit of anyone other than the Customer; except with the
                    Customer’s prior written consent;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    not, directly or indirectly, disclose Customer Information
                    to any person other than its authorized employees and to the
                    extent required by Competent Public Authorities or as
                    otherwise, to the extent expressly required, by applicable
                    law
                  </p>
                </li>
              </ul>
              <p>
                Subject to paragraph 5.1 above, all information and documents
                (whether financial, technical or otherwise) obtained by either
                NIBSS or User or their employees, contractors, consultants or
                agent which are not published or otherwise publicly available
                shall be kept confidential and not disclosed to third parties or
                the public except with the prior written approval of the other
                Party or as required by laws of the Federal Republic of Nigeria.
                This prohibition shall not prevent either Party, with the
                written consent of the other from issuing press releases
                containing non-sensitive information in relation to the
                relationship between the Parties.
              </p>
              <p>
                This entire clause 8 and the Parties’ obligations of
                confidentiality shall survive termination of this GTC and this
                clause 8.3 shall supersede similar provision(s) as to duration
                of confidentiality obligations contained in any other agreement
                between the Parties.
              </p>
              <p>
                The NIBSS Electronic Portals and Services and all data contained
                thereon and obtained therefrom shall remain the property of
                NIBSS and NIBSS reserves the right to disallow access to User at
                any time.
              </p>
              <p>
                NIBSS may request User to promptly return or to destroy Customer
                Information in whatever form preserved where NIBSS reasonably
                anticipates that breach of confidentiality has or is very likely
                to occur.
              </p>
              <p>
                NIBSS shall always exercise due care to ensure that the Customer
                information is secured and protected. However, NIBSS shall not,
                in any event, be liable for any litigation, breach or disclosure
                that may occur if it is compelled by law, regulation, and
                Government Authorities to disclose Customer information to third
                parties.
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="obligation-to-cooperate"
            >
              <h5>Obligation to Cooperate</h5>
              <p>
                The Parties shall cooperate with one another in order to achieve
                the objectives of this GTC. Whenever a consent or approval is
                required by one Party from another Party, such consent or
                approval shall be in writing and not be unreasonably withheld or
                delayed.
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="indemnity"
            >
              <h5>Indemnity</h5>
              <p>
                User undertakes to indemnify, defend and hold harmless NIBSS,
                its subsidiaries, affiliates, officers, directors, employees,
                agents, successors from and against all losses due to data
                security breach or the unauthorized use of shared personal
                information, any loss of funds, fraud, damages, actions,
                interest, awards, demands, liabilities, actions, judgment,
                penalties, fines, costs or expenses of whatever kind, including
                reasonable attorneys’ fees, damages and proceedings that may be
                made by any third party arising as a consequence of negligence
                and unlawful acts or omissions on the part of User or its agents
                or subcontractors to comply with any of its obligations in this
                GTC or the NDPR
              </p>
              <p>
                User agrees to defend NIBSS against any such liability, claim or
                demand in clause 10.1 above. NIBSS agrees to notify User
                promptly of any written claims or demands against NIBSS for
                which User is responsible hereunder.
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="limitation-of-liability"
            >
              <h5>Limitation of Liability</h5>
              <p>NIBSS shall not be liable:</p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>
                    for any damage from or in connection with the services
                    herein provided where such damages was not as a result of
                    NIBSS’ negligence or gross misconduct;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    for any claim arising out of any act or omission of User or
                    any other entity or third party furnishing services in
                    conjunction with the services provided herein;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    for any unlawful or unauthorized use of the services
                    provided hereunder by User, its employees or agents;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    in any event whatsoever, to User, or anyone else for
                    special, collateral, exemplary, indirect, incidental or
                    consequential damages (including without limitation, loss of
                    goodwill, loss of profit or revenue, loss of savings, loss
                    of use, business interruptions, and claims of/against User,
                    even if NIBSS had been advised of the possibility of such
                    damages, except as provided in this GTC; and
                  </p>
                </li>
              </ul>
              <p>
                The remedies of User set forth herein are exclusive and in lieu
                of all other remedies, express or implied. Except as provided
                for in this GTC, NIBSS shall not be liable for any further
                damages in performing the services
              </p>
              <p>
                Unless and to the extent prohibited by law, the liability of
                NIBSS and the liability of its subsidiaries and affiliates,
                officers, directors, agents, joint ventures, employees and
                suppliers, to User or any third parties in any circumstance is
                limited to the actual amount of direct damages finally proven.
                However, in no event whatsoever shall the maximum liability of
                NIBSS exceed the sum of ₦50, 000, 000 (Fifty Million Naira)
              </p>
            </section>
            <section className="terms-and-conditions-body-section" id="privacy">
              <h5>Privacy</h5>
              <p>
                User shall be liable for any breach of its obligations to ensure
                the security and privacy of its data holdings, including:
              </p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>
                    The prevention of unauthorized access to the Unique
                    Information that it holds;{" "}
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    The privacy of any Unique Information that may be collected,
                    used or disclosed by it as a result of its service offering;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Compliance with applicable data protection laws and act only
                    for the purposes authorised by NIBSS.
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Implement appropriate technical, physical and organisational
                    security measures to secure Account Holder’s Information
                    against unauthorised disclosure (including remote access),
                    or access, and against all other forms of unlawful
                    processing (including unnecessary collection or further
                    processing)
                  </p>
                </li>
              </ul>
              <p>
                Keep the Unique Information confidential and shall not disclose
                same in any way to any third party except where, (i) the
                disclosure is strictly necessary for the performance of services
                on behalf of the Account Holder, or (ii) where the Unique
                Information needs to be disclosed to a Competent Public
                Authority to comply with a legal obligation. User shall ensure
                that its employees are made aware of its obligations under this
                GTC and be placed under similar obligation of confidentiality
                and privacy
              </p>
              <p>
                Use of data processors to process personal data, provided that
                User (a) ensure(s) that any engaged data processor shall abide
                by data protection requirements no less stringent than that
                provided in this GTC, (b) remain(s) fully liable to NIBSS for
                the data processor’s acts or omissions in regard to its
                processing, (c) and informs NIBSS of the data processors
                engagement.
              </p>
              <p>Promptly inform NIBSS if:</p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>
                    it is unable to comply with its obligations under this GTC
                    because of legal requirements;{" "}
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    it receives an inquiry, a subpoena or a request for
                    inspection or audit from a Competent Public Authority
                    relating to the processing;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    it intends to disclose the Unique Information to a Competent
                    Public Authority;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    it detects or reasonably suspects that an unauthorised
                    access to the NIBSS platform or Electronic Portals and
                    Industry Services, use, loss, theft, destruction or
                    disclosure of Unique Information ("Data Security Breach")
                    has occurred. Such notice shall be sent per e-mail to
                    info@nibss-plc.ng.com
                  </p>
                </li>
              </ul>
              <p>
                In the event of a Data Security Breach, User shall promptly take
                adequate remedial measures, and provide NIBSS regarding measures
                taken including any additional information NIBSS may request
                relating to the data security breach. User shall fully cooperate
                with NIBSS to develop and execute a response plan to address the
                data security breach
              </p>
              <p>
                User shall be liable to NIBSS for any breaches by User and/or
                User’s processors of its data protection obligations under the
                GTC. NIBSS shall have the right to reasonably verify Your/User’s
                compliance of its data protection obligations under these Terms
                and Conditions.
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="no-third-party-rights"
            >
              <h5>No Third Party Rights</h5>
              <p>
                Nothing in this GTC, whether express or implied, is intended or
                shall be construed to confer, directly or indirectly, upon or
                give to any person, other than NIBSS and the User hereto, any
                legal or equitable right, remedy or claim under or in respect of
                this GTCor any covenant, condition or other provision contained
                herein
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="password-security"
            >
              <h5>Password Security.</h5>
              <p>
                User/You are responsible for maintaining adequate security and
                control of any and all IDs, passwords, personal identification
                numbers (PINs), or any other codes that You use to access the
                NIBSS Electronic Portals and Services.
              </p>
            </section>
            <section className="terms-and-conditions-body-section" id="taxes">
              <h5>Taxes</h5>
              <p>
                Parties shall be responsible for their respective levies,
                charges, contributions or taxes in connection with the service,
                including obtaining tax certificate or exemption certificate as
                may be required in accordance with the provisions of any laws,
                regulations or directives for the time being in force in
                Nigeria.
              </p>
            </section>

            <section
              className="terms-and-conditions-body-section"
              id="terms-of-payment"
            >
              <h5>Terms of Payment</h5>
              <p>
                The processing/transaction fee charged by NIBSS shall be
                deducted from source, i.e. an account designated by User for
                that purpose or from the settlement account at the CBN.
              </p>
              <p>
                All debit passed to the designated account must be honored by
                User while return debit will attract suspension of the Principal
                Account and NIBSS services until the sum accrued is paid.
              </p>
              <p>
                The Parties further agree that the charges may be reviewed in
                line with industry agreements from time to time and NIBSS will
                communicate the price change within fourteen (14) days of such
                change through a letter duly signed by an authorised signatory
                of NIBSS.
              </p>
              <p>
                {" "}
                In the event that User decides to pay the transaction fees but
                delays, fails, refuses, neglects or defaults in making payment,
                User shall pay interest at the current commercial bank lending
                rate for the period of default or delay notwithstanding the
                existence or otherwise of any legal proceeding during the period
                of the delay or default.
              </p>
              <p>
                That any and all payments made or payable by User pursuant to
                this GTC shall be made without any set-off or counterclaim.
              </p>
              <p>
                That NIBSS is authorised to debit User deposit account with all
                payments payable by or due from User in furtherance of this GTC
                or any other agreement between User and NIBSS.{" "}
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="restricted-activities"
            >
              <h5>Restricted Activities</h5>
              <p>
                In connection with Your use of NIBSS Electronic Portals and
                Industry Services, Our service platforms, Your Principal
                Account, NIBSS payment services, or in the course of Your
                interactions with NIBSS, other users, or third parties, You will
                not:
              </p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Breach this GTC, other applicable terms and conditions or
                    any other Policy or agreement that You have agreed to with
                    NIBSS
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>Violate any law, statute, ordinance, or regulation</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Infringe NIBSS's or any third party's copyright, patent,
                    trademark, trade secret or other intellectual property
                    rights, or rights of publicity or privacy
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Act in a manner that is defamatory, trade libelous,
                    threatening or harassing to NIBSS, Our employees, agents or
                    other users;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p> Provide false, inaccurate or misleading information;</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Engage in potentially fraudulent or suspicious activity
                    and/or transactions;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Refuse to cooperate in an investigation or provide
                    confirmation of Your identity or any information You provide
                    to us;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Conduct Your business or use the NIBSS Electronic Portals
                    and Services in a manner that results in or may result in
                    complaints, disputes, claims, reversals, chargebacks, fees,
                    fines, penalties and other liability to NIBSS, other users,
                    third parties or You;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Use the services in a manner that NIBSS, a card scheme or
                    any other electronic funds transfer network reasonably
                    believes to be an abuse of the financial system or a
                    violation of NIBSS or network rules
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Disclose or distribute another user's information to a third
                    party, or use the information for marketing purposes unless
                    You receive the third party’s express consent to do so;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Facilitate any viruses, Trojan horses, worms or other
                    computer programming routines that may damage, detrimentally
                    interfere with, surreptitiously intercept or expropriate any
                    system, data or information;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Use an anonymizing proxy; use any robot, spider, other
                    automatic device, or manual process to monitor or copy the
                    NIBSS’ website without NIBSS’ prior written permission;
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Use any device, software or routine to bypass Our robot
                    exclusion headers, or interfere or attempt to interfere with
                    the NIBSS website or the NIBSS Electronic Portals and
                    Industry Services;
                  </p>
                </li>
              </ul>
              <p>
                If NIBSS, reasonably believes that User may have engaged in any
                Restricted Activities, NIBSS may suspend, or limit Your access
                to Your Principal Account or any NIBSS Electronic Portal and
                Industry Services; You shall be notified within 72 hours where
                NIBSS has had cause to suspend or limit Your access accordingly,
                and given 7 days’ notice to refrain from such activities or
                remedy any breach and show to the reasonable satisfaction of
                NIBSS that this has been done. Should You fail to refrain from
                such activities or remedy such breach to the reasonable
                satisfaction of NIBSS upon the expiration of such 7 days’ notice
                given to You by NIBSS, NIBSS reserves the right to close Your
                account to the Electronic Portals and Industry Services until
                further notice.
              </p>
            </section>

            <section
              className="terms-and-conditions-body-section"
              id="grant-of-use"
            >
              <h5>Grant of Use</h5>
              <p>
                Subject to the provisions of this GTC and its duration thereof,
                NIBSS hereby grants to User and User accepts a limited,
                non-exclusive, non-transferable, non-assignable right to use its
                Product(s) for the purposes set forth in this GTC.
              </p>
              <p>
                User acknowledges that NIBSS is the exclusive owner of the
                Product(s) and that no license under any patents, copyrights,
                trademarks, trade secrets or any other intellectual property
                rights, express or implied is granted by NIBSS to the User under
                this GTC except as otherwise provided in this GTC
              </p>
              <p>
                In connection with the foregoing, User covenants and agree that
                it shall not;
              </p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Use the Product or any content delivered to it by NIBSS in a
                    way contrary to the terms and conditions of this GTC or the
                    Subscription Agreement.
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>Rent or lease the Product(s) or any part thereof</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    Circumvent any technology used by NIBSS or its licensors to
                    protect any accessible content.
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Provide its password to any other individual or organisation
                    or use any other individual or organisation’s username and
                    password
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    {" "}
                    Re-engineer, decompile, disassemble, modify or create
                    derivative works based on the Product(s) or any part thereof
                  </p>
                </li>
              </ul>
              <p>
                User agrees that the provisions of this clause 18 are reasonable
                having regard to the necessity of NIBSS to protect its ownership
                rights in the Product(s) and that any breach of the terms
                contained in this clause 18 shall be deemed a Material Breach of
                this GTC and in addition to any other remedies which may be
                available to it under this GTC, NIBSS shall be entitled to
                enforce its rights hereunder by specific performance or other
                injunctive or equitable relief so as to protect all its rights
                in and to its Product(s).
              </p>
            </section>

            <section
              className="terms-and-conditions-body-section"
              id="termination"
            >
              <h5>Termination</h5>
              <p>
                This GTC may be terminated in the circumstances and manner
                provided hereunder
              </p>
              <p>
                Automatically if, by reason of withdrawal of any governmental
                authorization, license, or permit, either Party is unable to
                fulfill its obligations herein stated
              </p>
              <p>
                By either Party upon willful default or a Material Breach by the
                other Party to perform any of its obligations under this GTC, if
                such default is not corrected within thirty (30) days after
                written notice by the non-defaulting party. For the purposes of
                this GTC, a breach shall be deemed to be material if it is
                incapable of being remedied by payment and goes to the root of
                the GTC
              </p>
              <p>
                If NIBSS or User is wound up or liquidated whether provisionally
                or finally.
              </p>
              <p>
                Any termination (howsoever occasioned) shall not affect any
                accrued rights or liabilities of either Party nor shall it
                affect the coming into force or the continuance in force of any
                provision in this GTC or subsequent GTCs which are expressly or
                by implication intended to come into or continue in force on or
                after such termination.
              </p>
            </section>
            <section className="terms-and-conditions-body-section" id="notices">
              <h5>Notices</h5>
              <p>
                Any notice under this GTC shall be in writing and may be served
                on either Party personally, or by registered or recorded
                delivery mail.
              </p>
              <p>
                The notice shall be deemed properly served, if received by hand
                upon being delivered personally to the Party for whom it is
                intended; or in the case of registered or recorded delivery,
                five (5) days following deposit of same in the mail; if sent by
                facsimile or email, upon confirmation of delivery, or if sent by
                overnight delivery services, the next day
              </p>
              <p>
                All notices under this GTC shall be sent to the address provided
                by the Parties
              </p>
              <p>
                Each Party reserves the right by prior written notice to the
                other Party to change its address
              </p>
              <p>
                The commencement of the period of notice shall be a working day
                at normal working hours between the hours of 8.00am and 5.00pm
                and the period shall be exclusive of Saturday and Sunday
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="governing-law-and-dispute-resolution"
            >
              <h5>Governing Law and Dispute Resolution</h5>
              <p>
                This GTC shall be governed and construed in accordance with the
                laws of the Federal Republic of Nigeria.
              </p>
              <p>
                The Parties shall do all within their effort to settle any
                dispute arising between them amicably within thirty (30) days of
                written notification of any dispute by the affected party.
              </p>
              <p>
                Where Parties are unable to amicably resolve their dispute, such
                dispute, controversy or claim arising out of or relating to or
                in connection with this GTC, or the breach, termination or
                validity hereof shall be finally settled by a sole arbitrator in
                accordance with the Arbitration and Conciliation Act Cap A18
                Laws of the Federation of Nigeria 2004, for the time being in
                force at the time such arbitration is commenced (the
                “Arbitration Act”).
              </p>
              <p>
                Parties shall jointly appoint the sole arbitrator within thirty
                (30) days of the receipt by a party at the other party’s request
                to initiate arbitration. Where the Parties are unable to appoint
                their arbitrator within the prescribed time, the decision shall
                be made by the Chairman of the Governing Council of the Lagos
                Multi-Door Court House, Lagos State, Nigeria.
              </p>
              <p>
                The place of the arbitration shall be Lagos, Nigeria. The
                language of arbitration and award shall be English
              </p>
              <p>
                A Party shall not be entitled to suspend the performance of its
                obligations under this GTC because an arbitral proceeding has
                been initiated.
              </p>
              <p>
                Without prejudice to the right of a Party to seek interim
                preservative orders from a court of competent jurisdiction, the
                decision of the arbitrators shall be final and binding on the
                Parties.
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="parties-relationship"
            >
              <h5>Parties’ Relationship</h5>
              <p>
                This GTC shall not constitute or imply any partnership, joint
                venture, agency, fiduciary relationship or other relationship
                between the Parties other than the contractual relationship
                expressly provided for in this GTC
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="severability"
            >
              <h5>Severability</h5>
              <p>
                If any provision of the GTC is held by any competent authority
                to be invalid or unenforceable in whole or in part such
                provision shall be construed, limited or if necessary, severed
                to the extent necessary to eliminate such invalidity or
                unenforceability and the validity of the other provisions of the
                GTC and the remainder of the provision in question shall not be
                affected but shall remain in full force and effect. If the
                severed provision is critical to the performance of this GTC,
                then the Parties shall negotiate together with a view to
                agreeing upon a valid replacement provision of equivalent
                economic effect, which shall replace the severed provision and
                be inserted in this GTC.
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="entire-agreement"
            >
              <h5>Entire Agreement</h5>
              <p>
                This GTC, other agreements or terms and conditions(as
                applicable) and the Subscription Agreement entered into between
                NIBSS and User for the provision of the Product(s), including
                any schedules attached thereto, constitute the entire agreement
                and understanding between the Parties with respect to all
                matters herein and supersedes all prior oral or written
                agreements and understandings between the Parties with respect
                to the subject matter of this GTC. The entire agreement shall
                together constitute a single agreement between the Parties
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="conflict-of-agreements"
            >
              <h5>Conflict of Agreements</h5>
              <p>
                If there are any conflicts between the terms in this GTC and the
                Subscription Agreement or any other agreement between NIBSS and
                User, the terms in the Subscription Agreement shall prevail.
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="agreement-not-assignable"
            >
              <h5>Agreement Not Assignable</h5>
              <p>
                This GTC, the Subscription Agreement, and other agreements or
                terms and conditions (as applicable) that may be entered into
                between NIBSS and User shall not be assignable by User except
                with the written permission of NIBSS
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="conflict-of-agreements"
            >
              <h5>Conflict of Agreements</h5>
              <p>
                If there are any conflicts between the terms in this GTC and the
                Subscription Agreement or any other agreement between NIBSS and
                User, the terms in the Subscription Agreement shall prevail.
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="anti-bribery-corruption-and-terrorism"
            >
              <h5>Anti-Bribery, Corruption and Terrorism</h5>
              <p>
                The Parties are committed to observing the highest standards of
                legal and ethical behaviour in the conduct of their relationship
                under this GTC. The Parties hereby undertake to comply with the
                applicable provisions of the Anti-Corruption Laws, and all laws
                relating to Anti-Money Laundering, terrorism financing etc.
              </p>
              <p>
                Parties undertake that they will not and will ensure that their
                personnel, agents, contractors, subcontractors and other
                stakeholders, affiliates and subsidiaries etc. will not:
              </p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>
                    make, promise, or offer (or accept, request, receive or
                    agree to receive) any gift, payment, reward, rebate,
                    contribution, commission, or any improper influence,
                    incentive, inducement, or advantage of any kind (financial
                    or otherwise) (a “Bribe”), directly or indirectly, to or
                    from: any public official, administrative officer or
                    political party; any private entity, party or individual; or
                    any political or charitable organisations which would
                    contravene any applicable provisions of the Anti-Corruption
                    Laws applicable to NIBSS and User; and
                  </p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>
                    make, promise or offer (or accept, request, receive or agree
                    to receive) any small gift, payment or improper reward of
                    any kind, which might be considered a “facilitation” or
                    “grease” payment-a small payment made to facilitate or
                    expedite particular functions or services (“Facilitation
                    Payment”).
                  </p>
                </li>
              </ul>
              <p>
                Parties undertake that they will not, and will procure that
                their personnel, agents, contractors, subcontractors and other
                stakeholders, affiliates and subsidiaries etc. will not directly
                or indirectly engage in, promote or support other organisations
                or individuals who engage in or attempts to commit or promote or
                support terrorist activity or knowingly provide material support
                or resources to any individual or entity that commits, attempts
                to commit, facilitated, or participated in terrorist acts.
              </p>
              <p>
                Party undertake that they will not, and will procure that their
                personnel, agents, contractors, subcontractors and other
                stakeholders, affiliates and subsidiaries etc. will not engage
                in any fraudulent or unethical business practices or by an act
                or omission, including any misrepresentation knowingly misleads,
                or attempt to mislead, a party in order to obtain any financial
                or other advantage, or to avoid any obligation, to benefit the
                perpetrator or a related party
              </p>
              <p>
                Parties undertake that they have complied with all anti-money
                laundering laws and regulations, including without limitation to
                the Money Laundering (Prohibition) Act, 2011 and all other
                relevant guidelines
              </p>
              <p>
                Parties shall maintain policies and procedures designed to
                prevent, and which are likely to prevent, violations of the
                Anti-Corruption Laws and will conduct the requisite due
                diligence in connection with all its transactions and will
                maintain sufficient information to identify their respective
                customers for the purposes of all Anti-Corruption Laws.
              </p>
              <p>
                Any violation of this clause 26 will constitute a material
                breach of this GTC and either Party shall be entitled to
                terminate this GTC and any other agreement(s) or Subscription
                Agreement entered into between NIBSS and User.
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="personal-data-processing-and-protection"
            >
              <h5>Personal Data Processing and Protection</h5>
              <p>
                User(s) shall observe all applicable laws on Personal Data
                protection and/or privacy requirements of the Federal Republic
                of Nigeria, including, without limitation, the Constitution of
                the Federal Republic of Nigeria, and the Nigerian Data
                Protection Regulation 2019 (NDPR).
              </p>
              <p>
                Where User(s) receive any Personal Data, it shall ensure that it
                fully complies with the provisions of the NDPR and only deals
                with the data to fulfil its obligations under this
                GTC/Agreement. User(s) shall indemnify NIBSS for any breach of
                the NDPR which renders NIBSS liable for any costs, claims or
                expenses.
              </p>
              <p>
                In fulfilment of its obligations under the Act, User(s) shall
                each have such security measures or systems in place to ensure
                full compliance with the NDPR and all other applicable laws:
                such measures shall include but not limited to protecting
                systems from hackers, setting up firewalls, storing data
                securely with access to specific authorized individuals,
                employing data encryption technologies, developing
                organizational policy for handling Personal Data (and other
                sensitive or confidential data), protection of emailing systems
                and continuous capacity building for staff.
              </p>
              <p>
                User(s) shall take reasonable steps to ensure the reliability of
                any employee, agent or contractor of any Contracted Processor
                who may have access to Personal Data, ensuring in each case that
                access is strictly limited to those individuals who need to
                know/access the relevant Personal Data, as strictly necessary
                for the purposes of this GTC/Agreement, and to comply with
                Applicable Laws in the context of that individual’s duties to
                the contracted Processor, ensuring that all such individuals are
                subject to confidentiality undertakings or professional or
                statutory obligations of confidentiality.
              </p>
              <p>
                With the execution of this Agreement, User(s) shall not process
                Personal Data pursuant to this GTC/Agreement except the Data
                Subject consents to such Processing. All Personal Data acquired
                by Parties pursuant to the performance of obligations under this
                GTC/Agreement shall only be used for the purposes of this
                GTC/Agreement and shall not be further processed or disclosed
                without the Consent of the Data Subject
              </p>
              <p>
                When entrusting a Processor with Processing activities, User(s)
                shall use only processors providing sufficient guarantees, in
                particular in terms of expert knowledge, reliability and
                resources, to implement technical and organisational measures
                which will meet the requirements of the NDPR, including for the
                security of Processing.
              </p>
              <p>
                Where the Processor engages another sub-processor for carrying
                out specific processing activities on behalf of the Parties, the
                same data protection obligations as set out in this
                GTC/Agreement shall be imposed on that Processor and
                Sub-processor by way of a contract or other legal act under
                applicable data protection legislation and regulations including
                the NDPR
              </p>
              <p>
                Processor shall make available to NIBSS on request all
                information necessary to demonstrate compliance with this
                clause, and shall allow for and contribute to audits, including
                inspections, by NIBSS or an auditor appointed by the User(s) in
                relation to the Processing of NIBSS’ Personal Data by the
                Processors
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="indemnity"
            >
              <h5>Indemnity</h5>
              <p>
                User agrees to indemnify and keep NIBSS indemnified and defend
                it, at User’s own expense, against all costs, claims, damages or
                expenses incurred by NIBSS or for which NIBSS may become liable
                due to any failure by the User or its data Processor or User’s
                employees, agents, subcontractors or Sub-Processors to comply
                with any of its obligations under the Nigerian Data Protection
                Regulation (“NDPR”) or any other applicable legislation on data
                processing
              </p>
            </section>
            <section
              className="terms-and-conditions-body-section"
              id="release-of-NIBSS"
            >
              <h5>Release of NIBSS.</h5>
              <p>
                If a third party has a dispute with one or more Users in
                connection with the NIBSS services and/or breach of data
                security, such third party and User hereby release NIBSS and
                Affiliates (and their officers, directors, agents, joint
                ventures, employees and suppliers) from any and all claims,
                demands and damages (actual and consequential) of every kind and
                nature arising out of or in any way connected with such
                disputes. User shall procure and ensure that all third parties
                are placed under similar obligation and written agreement
                releasing NIBSS from any and all claims, demands and damages
                (actual and consequential) of every kind and nature arising out
                of or in any way connected with such or any disputes.
              </p>
            </section>
          </main>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Terms;
